import StyleEventHook from './StyleEventHook'
import { bidderCode } from '../utils'
import Logger from '../Log'

const Log = Logger.for('BidderStyleHook')

/*
This applies custom style or related overrides when the slot
has been attached to the page with container styling applied
 */
export default class BidderStyleHook extends StyleEventHook {
  constructor () {
    super('StyleEventHook')
  }

  async run (bid, slot) {
    const bidder = bidderCode(bid.bidder)
    if (bidder === 'teads') {
      Log.info('Applying max width to teads node container')
      slot.node().style['max-width'] = '500px'
      slot.node().style.margin = 'auto'
    }
  }
}
